/**
 * Instance Emissor funding: toggle + bound PIX key + locked origin document.
 *
 *   GET  /v1/cards/issuer/funding   scope cards.read (operators: read-only)
 *   PUT  /v1/cards/issuer/funding   Valut admin + cards.write
 */

import { baasProxy } from "./baasConsoleClient";

const mapPixKey = (raw) => {
  if (!raw) return null;
  return {
    keyId: raw.key_id || raw.keyId || "",
    key: raw.key || "",
    keyType: raw.key_type || raw.keyType || "",
    originAccountId: raw.origin_account_id || raw.originAccountId || "",
    originAccountLabel: raw.origin_account_label || raw.originAccountLabel || "",
    linkedAccountId: raw.linked_account_id || raw.linkedAccountId || "",
    linked: Boolean(raw.linked),
    availableToLink: Boolean(raw.available_to_link || raw.availableToLink),
  };
};

export const mapIssuerFundingToUi = (api) => {
  if (!api) return null;
  const available = Array.isArray(api.available_keys) ? api.available_keys : [];
  const issuance = String(api.card_issuance_entity_type || api.cardIssuanceEntityType || "both")
    .trim()
    .toLowerCase();
  return {
    enabled: Boolean(api.enabled),
    programReserveAccountId: api.program_reserve_account_id || null,
    lockedOriginDocument: api.locked_origin_document || "",
    lockedOriginEditable: Boolean(api.locked_origin_editable),
    pixKey: mapPixKey(api.pix_key),
    availableKeys: available.map(mapPixKey).filter(Boolean),
    pixKeyProgramCount: Number(api.pix_key_program_count ?? 0) || 0,
    needsManualAllocation: Boolean(api.needs_manual_allocation),
    manualAllocationNote: api.manual_allocation_note || "",
    maxCardPrograms: Number(api.max_card_programs ?? api.maxCardPrograms ?? 10) || 10,
    cardProgramCount: Number(api.card_program_count ?? api.cardProgramCount ?? 0) || 0,
    cardIssuanceEntityType:
      issuance === "pf" || issuance === "pj" || issuance === "both" ? issuance : "both",
    raw: api,
  };
};

export const fetchIssuerFunding = async (instance, options = {}) => {
  if (!instance) return null;
  const data = await baasProxy({
    instance,
    method: "GET",
    baasPath: "v1/cards/issuer/funding",
    signal: options.signal,
  });
  return mapIssuerFundingToUi(data);
};

export const putIssuerFunding = async (instance, body, options = {}) => {
  if (!instance) {
    const err = new Error("BaaS instance is required");
    err.name = "BaasConsoleError";
    err.code = "instance_required";
    throw err;
  }

  const data = await baasProxy({
    instance,
    method: "PUT",
    baasPath: "v1/cards/issuer/funding",
    body,
    signal: options.signal,
  });
  return mapIssuerFundingToUi(data);
};
